import { ChangeDetectorRef, Component, EventEmitter, HostBinding, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { SessionService } from '@shared/services/session.service';
import { PreviewMode } from '../../../model/preview-mode';
import { FilePreviewBase } from '../../file-preview-types';
import { PreviewItemModel } from '../../file-preview.component';
import { ErrorType, StreamContentService } from '@shared/services/stream-content.service';

@Component({
  selector: 'file-preview-base',
  templateUrl: './base-preview.component.html',
  styleUrls: ['./base-preview.component.scss', '../../../file-preview-shared.scss'],
})
export class BasePreviewComponent implements FilePreviewBase, OnDestroy {
  constructor(
    protected cdr: ChangeDetectorRef,
    protected session: SessionService,
    protected streamContentService: StreamContentService
  ) {}

  @Input() set isRestricted(val: boolean) {
    if (val) {
      this.errorType = 'unEnablePreview';
    }
  }

  @Input() footerWidth: number;
  _previewMode: PreviewMode;

  @HostBinding('style.cursor')
  get cursor(): string {
    return this.previewMode !== 'popup' ? 'zoom-in' : 'default';
  }
  @HostBinding('class.padding')
  get isSidePreview() {
    return this.previewMode !== 'popup';
  }
  @HostBinding('style.display')
  get display() {
    return this.show ? 'flex' : 'none';
  }

  @Output() open = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @Output() download = new EventEmitter<any>();
  @Output() currentPage = new EventEmitter<number>();
  @Output() totalPages = new EventEmitter<number>();
  @Output() destroyed = new EventEmitter();
  @Input() token: string;
  @Input() set previewMode(val: PreviewMode) {
    this._previewMode = val;
    this.cdr.markForCheck();
  }

  get previewMode(): PreviewMode {
    return this._previewMode;
  }

  protected _model: PreviewItemModel;
  @Input() set model(model: PreviewItemModel) {
    this._model = model;
    this.modelValidated();
    this.cdr.markForCheck();
  }
  get model(): PreviewItemModel {
    return this._model;
  }

  protected _show: boolean;
  @Input() set show(show: boolean) {
    this._show = show;
  }
  get show() {
    return this._show;
  }

  protected _width = 50;
  @Input() set prevWidth(val: number) {
    this._width = val;
    this.cdr.markForCheck();
  }
  get prevWidth() {
    return this._width;
  }

  readonly minWidth = 10;
  readonly maxWidth = 100;
  loaded: boolean;
  errorType: ErrorType;

  modelValidated() {
    if (!this.model.fileType || !this.model.item?.srcUrl) {
      this.errorType = 'unsupportedFileType';
      this.loaded = true;
      return false;
    }
    return true;
  }

  scaleEl(el: HTMLElement, scale: number) {
    if (!el) return;
    el.style.transform = `scale(1.${scale})`;
    this.cdr.markForCheck();
  }

  protected finishLoad() {
    this.loaded = true;
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroyed.emit();
  }
}
